import { Action } from '@ngrx/store';

import { UserRecordsResults } from '®shared/user';

export enum UserSearchActionTypes {
  USER_SEARCH_INITIATED = '[User search] Search initiated',
  USER_SEARCH_CLEARED = '[User search] Search term cleared',
  USER_SEARCH_FAILED = '[User search] Search failed',
  USER_SEARCH_RESULTS_LOADED = '[User search] Search results loaded',
}

export interface UserSearchPayload {
  searchTerm: string;
  limit: number;
}

export class UserSearchInitiatedAction implements Action {
  readonly type = UserSearchActionTypes.USER_SEARCH_INITIATED;

  constructor(public payload: UserSearchPayload) {}
}

export class UserSearchClearedAction implements Action {
  readonly type = UserSearchActionTypes.USER_SEARCH_CLEARED;
}

export interface UserSearchFailedPayload extends UserSearchPayload {
  error: any;
}

export class UserSearchFailedAction implements Action {
  readonly type = UserSearchActionTypes.USER_SEARCH_FAILED;

  constructor(public payload: UserSearchFailedPayload) {}
}

export interface UserSearchResultsLoadedPayload extends UserSearchPayload {
  results: UserRecordsResults;
}

export class UserSearchResultsLoadedAction implements Action {
  readonly type = UserSearchActionTypes.USER_SEARCH_RESULTS_LOADED;

  constructor(public payload: UserSearchResultsLoadedPayload) {}
}

export type UserSearchActions =
  | UserSearchClearedAction
  | UserSearchFailedAction
  | UserSearchInitiatedAction
  | UserSearchResultsLoadedAction;
